<template>
  <BackgroundImage
    v-if="background && background[0] && background[0]._type === 'imageBackground'"
    v-bind="background[0]"
    background-size="full-page"
  >
    <slot />
  </BackgroundImage>
  <div
    v-else
    :class="sectionClasses"
  >
    <slot />
  </div>
</template>

<script lang="ts" setup>
import BackgroundImage from '~/components/Atmos/BackgroundImage/BackgroundImage.vue';
import type { BackgroundTheme } from '~/sanity/types';
import { backgroundColorClasses } from './BgColorMap';
const props = defineProps<{ theme?: BackgroundTheme }>();
const background = ref(props.theme?.background);

const sectionClasses = computed(() => ({
  'bg-wrapper h-full': true,
  [backgroundColorClass.value]: true,
}));

const backgroundColorClass = computed(() => {
  if (
    !background.value ||
    !background.value[0] ||
    !background.value[0].background ||
    background.value[0]._type !== 'colorBackground' ||
    !backgroundColorClasses[background.value[0].background]
  ) {
    return '';
  }
  return backgroundColorClasses[background.value[0].background];
});
</script>

<style scoped></style>
